import { useHistory, useParams } from "react-router";
import { useManageFeatureInstanceDetails } from "entity-app/hooks/feature-details-page";
import { useContext } from "react";
import {
  isPermissionNotGrantted,
  ProjectContext
} from "context/ProjectProvider";
import { ProjectPermissionEnum } from "constants/index";
import FeatureHeader from "pages/preconstruction-details/components/bid-package-header";
import { FeatureTypes } from "entity-app/constants";
import DesignPackageDetailsTab from "./design-package-detail-tab";

function DesignPackageDetailPage() {
  const history = useHistory();
  const { projectId, designPackageId } = useParams() as any;

  const { featureInstanceData, actions } = useManageFeatureInstanceDetails(
    designPackageId,
    FeatureTypes.DESIGN_PACKAGE
  );

  const goBackToList = () => {
    history.push(`/project/${projectId}/design-packages`);
  };
  const { tokenContents } = useContext(ProjectContext);
  const cannotWriteAccessOfDesignPackage = isPermissionNotGrantted(
    ProjectPermissionEnum.DesignPackageWrite,
    tokenContents?.role!
  );

  return (
    <div className="grow flex-col bg-ciq-gray-600">
      <FeatureHeader
        title="Design Package Details"
        actions={actions}
        number={featureInstanceData?.number}
        headerTitle={featureInstanceData?.title}
        status={featureInstanceData?.feature_workflow_instance?.milestone_state}
        disabled={cannotWriteAccessOfDesignPackage}
        goBackToList={goBackToList}
        feature="DESIGN_PACKAGE"
      />

      <DesignPackageDetailsTab
        featureInstanceData={featureInstanceData}
        actions={actions}
        featureId={designPackageId}
      />
    </div>
  );
}

export default DesignPackageDetailPage;
